import {
  decode as msgpackDecode,
  encode as msgpackEncode
} from '@msgpack/msgpack';
import SpringConfigs from 'utils/constants/swarm/spring-configs';

export const encode = (data: any): Uint8Array | string => {
  if (SpringConfigs.SWARM_BINARY_MESSAGE_ENABLED) {
    console.info(data);

    return msgpackEncode(data);
  }

  return JSON.stringify(data);
};

export const decode = (data: string | ArrayBuffer | Uint8Array | Blob): any => {
  if (!SpringConfigs.SWARM_BINARY_MESSAGE_ENABLED && typeof data === 'string') {
    return JSON.parse(data);
  }

  if (data instanceof ArrayBuffer) {
    try {
      console.info(msgpackDecode(new Uint8Array(data)));

      return msgpackDecode(new Uint8Array(data));
    } catch (msgpackError) {
      throw new Error(`Failed to decode binary data.`);
    }
  } else {
    throw new Error(`Unsupported data type: ${typeof data}`);
  }
};
